export default "__VITE_ASSET__c9f2f879__"